import { Component, OnInit } from '@angular/core';
import { ServiceService } from '../service.service';

class ImageSnippet {
  constructor(public src: string, public file: File) {}   //image uploading
}


@Component({
  selector: 'app-customer-compliant',
  templateUrl: './customer-compliant.component.html',
  styleUrls: ['./customer-compliant.component.css']
})
export class CustomerCompliantComponent implements OnInit {

  constructor(private customerService:ServiceService) { }
  selectedFile: ImageSnippet | undefined;   //image uploading

  //complaintUrl='http://192.241.151.66:5000/viewCustomers/customer_list/customer_complaints'
  //uploadUrl='http://192.241.151.66:5000/updateEmployees/employee_document'
  output:any=[]
  currentInput=""
  message=""
  link=''
  ngOnInit(): void {

    this.customerService.CustomerComplaints().subscribe((res)=>{
    this.output=res.data
    
        })
  }

}
